import { render, staticRenderFns } from "./Arbitrage.vue?vue&type=template&id=ef7ead40&"
import script from "./Arbitrage.vue?vue&type=script&lang=js&"
export * from "./Arbitrage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports